<div
  class="spinner"
  *ngIf="isLoading"
  [ngStyle]="{'height.px': spinnerHeight}"
  [ngClass]="{spinner_lg: isGlobal}"
>
  <mat-spinner mode="indeterminate" strokeWidth="5" [diameter]="diameter"></mat-spinner>
</div>
